import { useState, useMemo } from "react";
import { useNavigate } from "react-router-dom";
// import { AuthContext } from "../../providers/AuthProvider";
import LoginForm from "../components/LoginForm"; // Assuming you have these components
import RegisterForm from "../components/RegisterForm";
import { useUserLogin, useUserRegister } from "../hooks/authHooks";
import ResponseError from "../../../http/ResponseError";
import { Icon } from "../../../components/icons/Icon";
import { user } from "../../../components/icons/authIcons";

// import "../assets/styles/authentication.css";

// const API = "https://pwa-server.test/api/v1";

export default function LoginPage() {
  // const [showLogin, setShowLogin] = useState(true); // true for login, false for register
  //
  // const { login } = useContext(AuthContext);
  // const [email, setEmail] = useState("davidal@citywit.com");
  // const [password, setPassword] = useState("David@Broderick70!");
  // const [error, setError] = useState(null);
  // const navigate = useNavigate();

  // const { login } = useContext(AuthContext);
  const navigate = useNavigate();

  const [active, setActive] = useState("login"); // "login" | "register"
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(null);

  // const handleSubmit = async (e) => {
  //   e.preventDefault();
  //   setError(null);
  //   try {
  //     await login(email, password); // server + context update
  //     navigate("/", { replace: true });
  //   } catch (err) {
  //     setError(err.message || "Login failed");
  //   }
  // };
  //
  // const toggleForm = (tab) => {
  //   if (tab === "login") setShowLogin(true);
  //   if (tab === "register") setShowLogin(false);
  // };

  // const toggleLoginForm = (e) => {
  //   toggleForm("login");
  //   const registerEl = document.getElementById("pills-register-tab");
  //   registerEl.classList.remove("active");
  //   if (!e.target.classList.contains("active"))
  //     e.target.classList.toggle("active");
  // };

  // const toggleRegisterForm = (e) => {
  //   toggleForm("register");
  //   const loginEl = document.getElementById("pills-login-tab");
  //   loginEl.classList.remove("active");
  //   if (!e.target.classList.contains("active"))
  //     e.target.classList.toggle("active");
  // };

  // Reset messages when switching tabs
  const switchTab = (tab) => {
    setActive(tab);
    setError(null);
    setSuccess(null);
  };

  const status = useMemo(
    () => ({ loading, error, success }),
    [loading, error, success]
  );

  const login = useUserLogin();
  const handleLoginSubmit = async ({ email, password }) => {
    setLoading(true);
    setError(null);
    setSuccess(null);
    try {
      const { status, data } = await login({ email, password });
      setSuccess(data?.message || "Login successful.");
      navigate("/", { replace: true });
    } catch (e) {
      if (e instanceof ResponseError) {
        // All these are available: e.status, e.data, e.text, e.headers, e.url
        if (e.status === 409 && e.data?.meta?.verified === false) {
          setError(e.data.message);
          // setShowResendVerification(true);
        } else {
          setError(e.data?.message || `Login failed (${e.status || "?"})`);
        }
      } else {
        setError(e?.message || "Unexpected error");
      }
    } finally {
      setLoading(false);
    }
    // previous
    // let result;
    // try {
    //   result = await login({ email, password });
    //   // await login(email, password); // updates context
    //   setSuccess("Login successful.");
    //   navigate("/", { replace: true });
    // } catch (e) {
    //   console.dir(e);
    //   console.log(result);
    //   setError(e.message || "Login failed");
    // } finally {
    //   setLoading(false);
    // }
  };

  const { register } = useUserRegister();
  const handleRegisterSubmit = async ({ name, fax, email, password }) => {
    setLoading(true);
    setError(null);
    setSuccess(null);
    try {
      const result = await register({ name, fax, email, password });
      console.log(result);
      if (result && result.success) {
        const link = result?.meta?.emailVerifyUrl ?? "";

        setSuccess(
          "Registration successful. Please verify your email using the link we emailed. " +
            link ?? ""
        );
      }
    } catch (e) {
      setError(e?.message ?? "Registration failed");
      // setError(
      //   "The article addresses the fact that men are less likely than women to see a doctor, and that this is one reason why men do not live as long as women. Another reason, of course, is that men are, statistically, 3.5 million times more likely than women to attempt to shoot objects off of each others' heads, and 468 trillion times more likely to accept a bet concerning whether its possible to jump into the swimming pool from the roof. But the big problem is that men tend to avoid going to see a doctor unless they're in a really bad way. How bad is really bad? To answer that question, I will quote Jim Sylvester, M.D., who is an emergency room physician and — even more impressive — a paying subscriber to this Substack. In the comments section to a previous post, he wrote:"
      // );
    } finally {
      setLoading(false);
    }
  };

  /* register is not a function
  const register = useUserRegister();
  const handleRegisterSubmit = async ({ name, email, password }) => {
    setLoading(true);
    setError(null);
    setSuccess(null);
    let result;
    try {
      // const r = await fetch(`${API}/auth/register`, {
      //   method: "POST",
      //   credentials: "include",
      //   headers: { "Content-Type": "application/json" },
      //   body: JSON.stringify({ name, email, password }),
      // });
      result = await register({ name, email, password });
      // if (!result.ok) throw new Error("Registration failed");
      console.log(result);
      // const data = await result.json();
      setSuccess("Registration successful. Please verify your email.");
      // optionally switch back to login
      // switchTab("login");
    } catch (e) {
      setError(e.message || "Registration failed");
    } finally {
      setLoading(false);
    }
  };
  */

  return (
    <div className="login-page-container d-flex justify-content-center  mt-5">
      <div className="tab-content-container card border-0 rounded">
        <ul
          className="nav nav-pills nav-fill nav-justified mb-3"
          id="pills-tab"
          role="tablist"
        >
          <li className="nav-item" role="presentation">
            <a
              className={active === "login" ? "active nav-link" : " nav-link"}
              id="pills-login-tab"
              data-toggle="pill"
              href="#pills-login"
              role="tab"
              aria-controls="pills-login"
              aria-selected="true"
              onClick={() => switchTab("login")}
            >
              <Icon icon={user} height={16} width={16} size={16} />
              Login
            </a>
          </li>
          <li className="nav-item login text-center">
            <a
              className={
                active === "register" ? "active nav-link" : " nav-link"
              }
              id="pills-register-tab"
              data-toggle="pill"
              href="#pills-register"
              role="tab"
              aria-controls="pills-register"
              aria-selected="false"
              onClick={() => switchTab("register")}
            >
              Register
            </a>
          </li>
        </ul>
        <div className="tab-content" id="pills-tabContent">
          {/* {showLogin ? <LoginForm onSubmit={handleSubmit} /> : <RegisterForm />} */}
          {active === "login" ? (
            <LoginForm
              onSubmit={handleLoginSubmit}
              status={status}
              disabled={loading}
              // key forces child state reset when toggling tabs (optional)
              key="login"
            />
          ) : (
            <RegisterForm
              onSubmit={handleRegisterSubmit}
              status={status}
              disabled={loading}
              key="register"
            />
          )}
        </div>
      </div>
    </div>
  );

  //   <div>
  //     {showLogin ? <LoginForm /> : <RegisterForm />}
  //     <button onClick={toggleForm}>
  //       {showLogin ? "Switch to Register" : "Switch to Login"}
  //     </button>
  //   </div>
  // );
}

// export default LoginPage;
